export default __webpack_public_path__ + "static/media/MIA_StandAlone.bdfc7d83.svg";